/* eslint-disable react/function-component-definition */
/* eslint-disable import/no-unresolved */
import { useFormik } from "formik";
import { FC, memo, useEffect, useState } from "react";
import { MedicalQuestionnaireAPIData } from "src/helpers/FormDetails/ProposalDetails/interfaces";
import {
  calcAgeFromToday,
  constructFormikProps
} from "src/helpers/FormDetails/ProposalDetails/resources";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import ReviewHeading from "src/shared/ReviewHeading";
import UWQuestionnaire from "../../../../../shared/UWQuestionnaire";

interface Props {}

const JointLifeMedicalV2: FC<Props> = () => {
  const questionnaire: MedicalQuestionnaireAPIData.QuestionnaireReducer = useAppSelector(
    (state) => state?.masterdata_reducer?.questionnaire
  );
  const gender = useAppSelector((state) => state.jointLifeAddendum?.member?.genderCode) || "";
  const [formikProperties, setFormikProperties] = useState<Record<string, any>>({
    initialValues: {},
    validationSchema: null
  });
  const [errorJSON, setErrorJSON] = useState<Record<string, any>>({});
  const medicalLifeStyleV2Data = useAppSelector(
    (state) => state?.jointLifeAddendum?.medicalDetailsV2
  );
  const sumAssured = useAppSelector((state) => state?.common?.leadDetails?.sumAssured);
  const jointLifeDob = useAppSelector((state) => state?.jointLifeAddendum?.member?.dob) || "";
  const age = calcAgeFromToday(jointLifeDob);

  const formik = useFormik({
    enableReinitialize: true,
    validateOnMount: true,
    validateOnChange: true,
    validateOnBlur: true,
    initialValues: formikProperties?.initialValues || {},
    ...(formikProperties?.validationSchema && {
      validationSchema: formikProperties?.validationSchema
    })
  });

  useEffect(() => {
    const { initialValues, validationSchema } = constructFormikProps(
      questionnaire,
      { gender, sumAssured, age },
      medicalLifeStyleV2Data!
    );
    console.log("setting initial values", initialValues);
    formik.setValues(initialValues);
    setFormikProperties({ initialValues, validationSchema });
  }, [medicalLifeStyleV2Data, questionnaire]);

  return (
    <div className="  font-montserrat">
      <div className="xl:ml-10 xl:mr-10 lg:ml-10 lg:mr-10 md:ml-10 md:mr-10 ml-4 mr-4">
        <ReviewHeading label="Medical & LifeStyle" />
      </div>
      <UWQuestionnaire
        formik={formik}
        errorJSON={errorJSON}
        setErrorJSON={setErrorJSON}
        editable={false}
      />
    </div>
  );
};

export default memo(JointLifeMedicalV2);
